import { settings } from '../../../settings/settings-util'
import reducer from './reducers/index'
import * as Actions from './actions/actions'
import watch from 'redux-watch'

export default class PersistentStorage
{
    constructor(passedSettings)
    {
        this._settings = passedSettings || settings;
        this._mappings = {};
    }

    static getDefaultSettings()
    {
        return settings;
    }

    getReducer()
    {
        return reducer;
    }

    initialize(store)
    {
        let watchStates = this._settings.stateLocations.PersistentStorage.watches;
        this._store = store;

        for(let i = 0, len = Object.keys(watchStates).length; i < len; i++)
        {
            let name = Object.keys(watchStates)[i];
            let locations = watchStates[name];
            for(let j = 0, locLen = locations.length; j < locLen; j++)
            {
                this._mappings[locations[j]] = name;
                let watcher = watch(this._store.getState, locations[j]);
                this._store.subscribe(watcher((newVal, oldVal, objectPath) => {
                    return this.handleStateChanged(newVal, oldVal, objectPath);
                }));
            }
        }
    }

    handleStateChanged(newVal, oldVal, objectPath)
    {
        let payload = {
            state : newVal,
            name : this._mappings[objectPath] || "default",
            path : objectPath
        };

        this._store.dispatch(Actions.persistStateChange(payload));
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/persistence/src/persistence.js